import { Card, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { FormcreateActivity } from "./components/form-create-activity";
import { useId24 } from "../../drivers/id24/Id24Provider";
import { ActivityService } from "./services/agendas-service";
import { Imasterdataagenda } from "./common/index";
import { loadAppConfig } from "../../configs/app-config";

const { Title } = Typography;

export const MainAgenda: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const [statusRefesh, setStatusRefesh] = useState<boolean>(true);
  const [masterDataAgenda, setMasterdataAgenda] = useState<Imasterdataagenda[]>([]);

  useEffect(() => {
    if (statusRefesh) {
      featchData();
    }
  }, [statusRefesh]);

  const featchData = async () => {
    console.log(apiBaseUrl);
    const resultAgenda = await ActivityService(apiBaseUrl).getMasterdataAgenda();
    console.log(resultAgenda);
    setMasterdataAgenda(resultAgenda);
    setStatusRefesh(false);
  };

  return (
    <>
      <Card>
        <Title level={3}>สร้างกิจกรรม</Title>
      </Card>
      <div className="divContent">
        <FormcreateActivity masterDataAgenda={masterDataAgenda} />
      </div>
    </>
  );
};
